"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftRatingMetric = void 0;
exports.instanceOfShiftRatingMetric = instanceOfShiftRatingMetric;
exports.ShiftRatingMetricFromJSON = ShiftRatingMetricFromJSON;
exports.ShiftRatingMetricFromJSONTyped = ShiftRatingMetricFromJSONTyped;
exports.ShiftRatingMetricToJSON = ShiftRatingMetricToJSON;
exports.ShiftRatingMetricToJSONTyped = ShiftRatingMetricToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftRatingMetric = {
    FacilityShiftQuality: 'FACILITY_SHIFT_QUALITY',
    FacilityPatientRatio: 'FACILITY_PATIENT_RATIO',
    FacilityTeamSupport: 'FACILITY_TEAM_SUPPORT',
    FacilityOperations: 'FACILITY_OPERATIONS',
    FacilitySupport: 'FACILITY_SUPPORT',
    FacilitySafety: 'FACILITY_SAFETY',
    NurseRehireLikelihood: 'NURSE_REHIRE_LIKELIHOOD',
    NurseSpecialtySkill: 'NURSE_SPECIALTY_SKILL',
    NurseTeamCooperation: 'NURSE_TEAM_COOPERATION',
    NursePatientCare: 'NURSE_PATIENT_CARE',
    NurseOperations: 'NURSE_OPERATIONS',
    NurseShiftQuality: 'NURSE_SHIFT_QUALITY',
    NursePunctuality: 'NURSE_PUNCTUALITY',
    NurseSafety: 'NURSE_SAFETY'
};
function instanceOfShiftRatingMetric(value) {
    for (const key in exports.ShiftRatingMetric) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftRatingMetric, key)) {
            if (exports.ShiftRatingMetric[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftRatingMetricFromJSON(json) {
    return ShiftRatingMetricFromJSONTyped(json, false);
}
function ShiftRatingMetricFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftRatingMetricToJSON(value) {
    return value;
}
function ShiftRatingMetricToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftRatingMetric.js.map